type LegalEmailLinkProps = {
  email: string;
};

export function LegalEmailLink({ email }: LegalEmailLinkProps) {
  return (
    <a href={`mailto:${email}`} className="text-blue-600 underline">
      {email}
    </a>
  );
}
